/**
 * constants for Connect Model
 * @type {Object}
 */
module.exports = {
    AUTH_TYPE_EMAIL: 'email',
    AUTH_TYPE_FB: 'facebook',
    AUTH_METHOD_EMAIL: 'email',
    AUTH_METHOD_FB: 'fb',
    ACTION_TYPE_GET: 'get',
    ACTION_TYPE_VOTE: 'vote'
};



// WEBPACK FOOTER //
// ./app/scripts/constants/connect.js